import type { ReactNode } from 'react';

interface ScreenProps {
  title?: string;
  subtitle?: string;
  headerLeft?: ReactNode;
  headerRight?: ReactNode;
  children: ReactNode;
}

export function Screen({ title, subtitle, headerLeft, headerRight, children }: ScreenProps) {
  return (
    <div className="screen relative" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
      <div className="screen-inner">
        {(title || subtitle || headerLeft || headerRight) && (
          <header className="screen-header">
            {headerLeft && <div className="absolute top-2 left-4">{headerLeft}</div>}
            <div className="flex-1 flex items-center justify-center flex-col">
              {title && <h1 className="screen-title text-center">{title}</h1>}
              {subtitle && <p className="screen-subtitle text-center">{subtitle}</p>}
            </div>
            {headerRight && <div className="shrink-0">{headerRight}</div>}
          </header>
        )}
        <main className="flex-1 min-h-0 pb-4 flex flex-col gap-3">{children}</main>
      </div>
    </div>
  );
}


